import React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Image from "next/image";

function SelectField(props) {
  const { statustData, handleChange, value } = props;

  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <div className="PM_SelectFieldContainer">
      <FormControl>
        <Select
          labelId="demo-controlled-open-select-label"
          id="demo-controlled-open-select"
          open={open}
          onClose={handleClose}
          onOpen={handleOpen}
          value={value}
          // defaultValue={props.defaultValue}
          label="Age"
          onChange={handleChange}
        >
          {statustData?.map((select, i) => (
            <MenuItem value={select.value}>
              <span className="MP_SelectFieldValue">
                <Image src={select.icon} /> {select.label}
              </span>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

export default SelectField;
